module.exports = __webpack_public_path__ + "img/udo.87bdad7.png";